import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import types from 'prop-types';
import { addEventListener, removeEventListener } from 'consolidated-events';
var propTypes = {
  children: types.node,
  onOutsideClick: types.func
};
var defaultProps = {
  onOutsideClick: function onOutsideClick() {}
};

var OutsideClickHandler = /*#__PURE__*/function (_React$Component) {
  _inherits(OutsideClickHandler, _React$Component);

  var _super = _createSuper(OutsideClickHandler);

  function OutsideClickHandler(props) {
    var _context, _context2;

    var _this;

    _classCallCheck(this, OutsideClickHandler);

    _this = _super.call(this, props);
    _this.onOutsideClick = _bindInstanceProperty(_context = _this.onOutsideClick).call(_context, _assertThisInitialized(_this));
    _this.bindClickListener = _bindInstanceProperty(_context2 = _this.bindClickListener).call(_context2, _assertThisInitialized(_this));
    return _this;
  }

  _createClass(OutsideClickHandler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _setTimeout(this.bindClickListener, 100);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.clickHandle) removeEventListener(this.clickHandle);
    }
  }, {
    key: "bindClickListener",
    value: function bindClickListener() {
      this.clickHandle = addEventListener(document, 'click', this.onOutsideClick, {
        capture: true
      });
    }
  }, {
    key: "onOutsideClick",
    value: function onOutsideClick(e) {
      if (!this.childNode || !this.childNode.contains(e.target)) {
        this.props.onOutsideClick(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(_ref) {
          _this2.childNode = _ref;
        }
      }, this.props.children);
    }
  }]);

  return OutsideClickHandler;
}(React.Component);

export { OutsideClickHandler as default };
OutsideClickHandler.propTypes = propTypes;
OutsideClickHandler.defaultProps = defaultProps;